<template>
  <div class="cpt-carousel">
    <div class="list">
      <div class="item">
        <div class="avatar">
          <img :src="carousel.heybox_info.avatar" />
        </div>
        <div class="desc" :style="fontColor" v-html="carousel.title"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt_carousel',
  props: ['carousel', 'mainColor', 'fontColor'],
};
</script>

<style lang="less">
.cpt-carousel {
  width: 100%;
  .list {
    height: 30px;
    overflow: hidden;
    span {
      margin: 0 5px;
    }
    .item {
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
      height: 100%;
      max-width: 90%;
      margin: auto;
      padding: 0 13px 0 8px;
      border-radius: 27px;
      background-color: rgba(255, 255, 255, 0.9);
      .avatar {
        width: 18px;
        height: 18px;
        margin-right: 6px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .desc {
        font-weight: 500;
        font-size: 12px;
        color: rgba(86, 130, 246, 1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
